import { render, staticRenderFns } from "./MentoringResume.vue?vue&type=template&id=5054085a&scoped=true&"
import script from "./MentoringResume.vue?vue&type=script&lang=js&"
export * from "./MentoringResume.vue?vue&type=script&lang=js&"
import style0 from "./MentoringResume.vue?vue&type=style&index=0&id=5054085a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5054085a",
  null
  
)

export default component.exports